import { EventEmitter, Injectable } from '@angular/core'
import { Subscription } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class SharedLinkUpdatedService {

    private sharedLinkUpdatedEmitter = new EventEmitter<string>()

    emit(value: string): void {
        this.sharedLinkUpdatedEmitter.emit(value)
    }

    subscribe(next?, error?, complete?): Subscription {
        return this.sharedLinkUpdatedEmitter.subscribe(next, error, complete)
    }
}